export const FETCH_DATA_PENDING = 'FETCH_DATA_PENDING_FEEDING_GUIDELINES_RECOMMENDED_ACTION';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS_FEEDING_GUIDELINES_RECOMMENDED_ACTION';
export const FETCH_DATA_ERROR = 'FETCH_DATA_ERROR_FEEDING_GUIDELINES_RECOMMENDED_ACTION';
export const DEFAULT = 'DEFAULT_FEEDING_GUIDELINES_RECOMMENDED_ACTION';

export function fetchDataPending() {
  return {
    type: FETCH_DATA_PENDING
  }
}

export function fetchDataSuccess(data) {
  return {
    type: FETCH_DATA_SUCCESS,
    data: data
  }
}

export function fetchDataError(error) {
  return {
    type: FETCH_DATA_ERROR,
    error: error
  }
}
